module.exports = __webpack_public_path__ + "static/bg-weedingakad-1e957a09033e42c392e1d1aae6b08ba6.png";